import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">Страница не найдена</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <a href="/" className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap no-underline">
          На главную
          <i className="ri-home-line text-base w-4 h-4 flex items-center justify-center"></i>
        </a>
      </div>
    </div>
  );
}